import MonthlyAttendance from "@/controllers/student/monthly_attendance/monthly-attendance-list.js";

export default {
  extends: MonthlyAttendance,
};
